import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { V3_APP_BASE_URL } from '@/constants/Config';
import type { ErrorResponse } from '@/common/interfaces/error.interface';
import type { PromoCodeUserRes } from '@/common/interfaces/promoCodeUser.interface';

/** Defining a service using a base URL and expected endpoints  */
export const promoCodeUserQuery = createApi({
  reducerPath: 'promoCodeUserQuery',
  tagTypes: ['PromoCodeUser'],
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  endpoints: (build) => ({
    postPromoCodeUser: build.mutation({
      query: (data) => ({
        url: `api/cp/promo-code-user`,
        method: 'POST',
        data,
      }),
      transformResponse: (response: PromoCodeUserRes) => response,
      transformErrorResponse: (response: ErrorResponse) => response,
      invalidatesTags: ['PromoCodeUser'],
    }),
    getActiveAppliedPromoCodeUser: build.query({
      query: () => ({
        url: `api/cp/promo-code-user/applied`,
        method: 'GET',
      }),
      transformResponse: (response: PromoCodeUserRes) => response,
      transformErrorResponse: (response: ErrorResponse) => response,
      providesTags: ['PromoCodeUser'],
    }),
    updatePromoCodeUser: build.mutation({
      query: ({ promoCodeUserId, data }) => ({
        url: `api/cp/promo-code-user/${promoCodeUserId}`,
        method: 'PUT',
        data,
      }),
      transformResponse: (response: { status: string; message: string }) => response,
      transformErrorResponse: (response: ErrorResponse) => response,
      invalidatesTags: ['PromoCodeUser'],
    }),
    deactivateActivePromoCodeUser: build.mutation({
      query: () => ({
        url: `api/cp/promo-code-user/deactivate`,
        method: 'PUT',
      }),
      transformResponse: (response: { status: string; message: string }) => response,
      transformErrorResponse: (response: ErrorResponse) => response,
      invalidatesTags: ['PromoCodeUser'],
    }),
  }),
});

/** Export hooks for usage in functional components, which are auto-generated based on the defined endpoints */
export const {
  usePostPromoCodeUserMutation,
  useGetActiveAppliedPromoCodeUserQuery,
  useUpdatePromoCodeUserMutation,
  useDeactivateActivePromoCodeUserMutation,
} = promoCodeUserQuery;
